import { router } from '@inertiajs/react';
import { Component } from 'react';
import { useTranslation } from 'react-i18next';

import BrandLockup from '@/components/brand-lockup';
import { Button } from '@/components/ui/button';
import Sentry from '@/lib/sentry';

function BrandedErrorFallback() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="w-full max-w-md rounded-2xl border bg-card p-8 text-center shadow-sm">
        <BrandLockup className="mb-8 justify-center" markClassName="size-12" />
        <h1 className="mb-4 text-2xl font-bold text-foreground">
          {t('error_boundary.title')}
        </h1>
        <p className="mb-6 text-muted-foreground">
          {t('error_boundary.description')}
        </p>
        <Button onClick={() => window.location.reload()}>
          {t('error_boundary.refresh')}
        </Button>
      </div>
    </div>
  );
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    // Reset error state on Inertia page navigation so a crash on one page
    // does not permanently lock out all subsequent pages.
    this.removeListener = router.on('navigate', () => {
      if (this.state.hasError) {
        this.setState({ hasError: false, error: null });
      }
    });
  }

  componentWillUnmount() {
    this.removeListener?.();
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      contexts: { react: { component_stack: errorInfo?.componentStack } },
    });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <BrandedErrorFallback />;
    }

    return this.props.children;
  }
}
